export default "__VITE_ASSET__BdxQWnAQ__"